import { Component, Inject, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderShipping, SearchOrderShippingCommand } from '@/app/shared/interface/order-shipping.interface';
import { OrderShippingService } from '@/app/shared/services/order-shipping-service';
import { OrderService } from '@/app/shared/services/order.service';

@Component({
  selector: 'app-order-shipping-modal',
  templateUrl: './order-shipping-modal.component.html',
  styleUrl: './order-shipping-modal.component.scss',
})
export class OrderShippingModalComponent {
  @ViewChild('orderShippingModal', { static: false }) thisModal: TemplateRef<string>;

  trackingUrl: string | undefined;
  trackingNumber: string;
  data: OrderShipping[] = [];
  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
    private orderShippingService: OrderShippingService,
    private orderService: OrderService,
  ) { }

  ngOnInit(): void {
  }

  openModal(trackingUrl: string | undefined, trackingNumber: string, orderId: string) {
    this.trackingUrl = trackingUrl;
    this.trackingNumber = trackingNumber;
    this.syncOrderShipping(orderId);
  }

  searchOrderShipping() {
    let request: SearchOrderShippingCommand = {
      ShippingCode: this.trackingNumber
    };
    this.orderShippingService.searchOrderShipping(request).subscribe({
      next: (res: OrderShipping[]) => {
        this.data = res;
        this.openModalDialog();
      }
    });
  }

  syncOrderShipping(orderId: string) {
    this.orderService.syncOrderShipping(orderId).subscribe({
      next: (res) => {
        this.searchOrderShipping();
      }
    });
  }

  private openModalDialog() {
    if (isPlatformBrowser(this.platformId)) {
      this.modalService.open(this.thisModal, {
        ariaLabelledBy: 'order-shipping-Modal',
        centered: true,
        windowClass: 'theme-modal modal-login',
      });
    }
  }
}

